/** @jsxRuntime classic */
/** @jsx jsx */
import { Link, Text } from '@bottlebooks/gatsby-theme-base';
import { Trans } from '@lingui/macro';
import { graphql } from 'gatsby';
import { jsx } from 'theme-ui';
import useLink from '../../useLink';
import { ProducerCard } from '../ProducersList';
import DistributionContacts from './BrandContacts/DistributionContacts';
import useSiteConfig from '../useSiteConfig';

export default function PresentedBrand({ brand, ...rest }) {
  const link = useLink();
  const { showDistributionDetails } = useSiteConfig();
  return (
    <ProducerCard
      key={brand.brandId}
      variant="info"
      producer={brand}
      to={link.producer(brand)}
      {...rest}
    >
      {['all', 'inMarket'].includes(showDistributionDetails) && (
        <DistributionContacts
          brand={brand}
          variant="card"
          sx={{
            backgroundColor: 'light',
            paddingX: 3,
            paddingBottom: 3,
            borderTop: 1,
            borderColor: 'border',
          }}
        />
      )}
      {['all', 'global'].includes(showDistributionDetails) &&
        brand.profile.distributors?.totalCount > 0 && (
          <Text sx={{ paddingX: 3, paddingBottom: 3 }}>
            {/* Scroll to distribution section */}
            <Link
              to={`${link.producer({
                producerId: brand.brandId,
              })}#distributors`}
            >
              <Trans>See global distribution</Trans>
            </Link>
          </Text>
        )}
    </ProducerCard>
  );
}

export const fragment = graphql`
  fragment bb_RegisteredBrand_PresentedBrand on Bottlebooks_RegisteredBrand {
    brandId
    companyId
    ...bb_ProducerCard_RegisteredBrand
    ...bb_DistributionContacts
    ...useLink_bb_RegisteredBrand
    profile {
      distributors {
        totalCount
      }
    }
  }
`;
